
import {
	ChangeDetectionStrategy,
	Component,
	Input
} from '@angular/core';

@Component({
	selector: 'feedback-display-header',
	templateUrl: './feedback-display-header.component.html',
	styleUrls: ['./feedback-display-header.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: []
})
export class FeedbackDisplayHeaderComponent {
	@Input() public title: string = '';
}
